<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()" tabindex="1">Close</button>
  <button mat-button [mat-dialog-close]="true" tabindex="-1">Ok</button>
</div>